export default "__VITE_ASSET__CmjIj2xv__"